var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Defaults, P, PropertyConverters, Utils, Watch } from '@pacem/pacem-core';
import { PacemContenteditableButtonCommandElement, CONTENTELEMENT_BUTTONCOMMAND_TEMPLATE } from './types';
import { ContenteditableUtils } from './utils';
//namespace Pacem.Components.Scaffolding {
export var KnownExecCommand;
(function (KnownExecCommand) {
    KnownExecCommand["Bold"] = "bold";
    KnownExecCommand["Italic"] = "italic";
    KnownExecCommand["Underline"] = "underline";
    KnownExecCommand["StrikeThrough"] = "strikeThrough";
    KnownExecCommand["OrderedList"] = "insertOrderedList";
    KnownExecCommand["UnorderedList"] = "insertUnorderedList";
    KnownExecCommand["JustifyLeft"] = "justifyLeft";
    KnownExecCommand["JustifyCenter"] = "justifyCenter";
    KnownExecCommand["JustifyRight"] = "justifyRight";
    KnownExecCommand["JustifyFull"] = "justifyFull";
    //Copy = 'copy',
    //Cut = 'cut',
    //Paste = 'paste'
    //Undo = 'undo',
    //Redo = 'redo',
})(KnownExecCommand || (KnownExecCommand = {}));
;
/**
 * Returns relevant material icon ligatures
 * @param cmd A known command
 */
function getKnownCommandIcon(cmd) {
    const lower_cmd = cmd?.toLowerCase();
    switch (lower_cmd) {
        case "bold":
        case "italic":
            return 'format_' + lower_cmd;
        case 'underline':
            return 'format_underlined';
        case 'strikethrough':
            return 'strikethrough_s';
        case 'insertorderedlist':
            return 'format_list_numbered';
        case 'insertunorderedlist':
            return 'format_list_bulleted';
        case 'justifyleft':
        case 'justifyright':
        case 'justifycenter':
            return 'format_align_' + lower_cmd.substr(7 /* 'justify' */);
        case 'justifyfull':
            return 'format_align_justify';
        default:
            return 'help_outline';
    }
}
function getKnownCommandFilters(cmd, argument) {
    const lower_cmd = cmd?.toLowerCase();
    switch (lower_cmd) {
        case "bold":
            return ['b', 'strong'];
        case "italic":
            return ['i', 'em'];
        case 'underline':
            return ['u'];
        case 'strikethrough':
            return ['strike', 's', 'del'];
        case 'insertorderedlist':
            return ['ol'];
        case 'insertunorderedlist':
            return ['ul'];
        case 'justifyleft':
            return [{ style: { name: 'text-align', value: 'left' } }];
        case 'justifyright':
            return [{ style: { name: 'text-align', value: 'right' } }];
        case 'justifycenter':
            return [{ style: { name: 'text-align', value: 'center' } }];
        case 'justifyfull':
            return [{ style: { name: 'text-align', value: 'justify' } }];
        case 'formatblock':
            return [argument];
        default:
            return ['none'];
    }
}
let PacemContenteditableExecCommandElement = class PacemContenteditableExecCommandElement extends PacemContenteditableButtonCommandElement {
    _matchRelevance(range, arg) {
        const found = (typeof arg === 'object') ?
            ContenteditableUtils.findSurroundingNode(range, node => node instanceof HTMLElement
                && (Utils.isNullOrEmpty(arg.tagName) || node.tagName === arg.tagName.toUpperCase())
                && node.style[arg.style.name] === arg.style.value)
            : ContenteditableUtils.findSurroundingNode(range, arg);
        return !Utils.isNull(found);
    }
    isRelevant(range) {
        const filters = getKnownCommandFilters(this.command, this.argument);
        for (let f of filters) {
            if (this._matchRelevance(range, f)) {
                return true;
            }
        }
        return false;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'command') {
            if (Utils.isNullOrEmpty(this.icon) || this.icon === getKnownCommandIcon(old)) {
                this.icon = getKnownCommandIcon(val);
            }
            if (Utils.isNullOrEmpty(this.altText) || this.altText === old) {
                this.altText = val;
            }
        }
    }
    exec() {
        return new Promise((resolve, _) => {
            // check if selection is around an 'inert' ([contenteditable=false]) element
            const r = this.range, cmdfilter = getKnownCommandFilters(this.command, this.argument)[0];
            if (!Utils.isNull(r)) {
                // #region wrap/unwrap (manages contenteditable=false 'islands')
                const island = ContenteditableUtils.testInertElementWrapping(r);
                if (island.result
                    && typeof cmdfilter === 'string' && ['b', 'i', 'strike', 'u'].indexOf(cmdfilter) >= 0) {
                    // wrap or remove?
                    const wrapper = ContenteditableUtils.findSurroundingNode(r, cmdfilter);
                    if (!Utils.isNull(wrapper) && wrapper.childNodes.length === 1) {
                        // remove
                        const newChild = wrapper.childNodes.item(0), select = island.element;
                        wrapper.parentElement.replaceChild(newChild, wrapper);
                        ContenteditableUtils.select(select);
                    }
                    else {
                        // wrap
                        const n = document.createElement(cmdfilter), select = island.element;
                        const frag = r.extractContents();
                        r.insertNode(n);
                        n.append(frag);
                        ContenteditableUtils.select(select);
                    }
                }
                // #endregion
                else {
                    document.execCommand(this.command, false, this.argument);
                }
            }
            resolve();
        });
    }
};
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemContenteditableExecCommandElement.prototype, "command", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemContenteditableExecCommandElement.prototype, "argument", void 0);
PacemContenteditableExecCommandElement = __decorate([
    CustomElement({
        tagName: P + '-contenteditable-execcommand', shadow: Defaults.USE_SHADOW_ROOT,
        template: CONTENTELEMENT_BUTTONCOMMAND_TEMPLATE
    })
], PacemContenteditableExecCommandElement);
export { PacemContenteditableExecCommandElement };
